import { nameByPlatform } from "~/constants/platfroms";
import { getPlatformTradeLink } from "~/feature/event/utils/getPlatformTradeLink";
import { usePlatformClick } from "~/hooks/usePlatformClick";
import type { PlatformClickPlacement } from "~/scripts/platformClick";
import type { IAggregatedEvent, IMarket } from "~/types/event";

export const usePlatformTradeLink = (
  market: IMarket,
  event: IAggregatedEvent,
  placement: PlatformClickPlacement
) => {
  const handleClick = usePlatformClick({
    platform: market.platform,
    placement,
    eventSlug: event.urlSlug ?? null,
  });

  return {
    href: getPlatformTradeLink(market, event),
    platformName: nameByPlatform[market.platform],
    handleClick,
  };
};
